import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import EstablishmentInfoForm from "../components/special-case/EstablishmentInfoForm";
import GeneralImportTypeForm from "../components/special-case/GeneralImportTypeForm";
import ImportTypeOneForm from "../components/special-case/ImportTypeOneForm";
import ImportTypeSevenForm from "../components/special-case/ImportTypeSevenForm";
import ImportTypeEightForm from "../components/special-case/ImportTypeEightForm";
import ImportDataView from "../components/special-case/ImportDataView";
import classnames from "classnames";
import Swal from "sweetalert2";

class SpecialCases extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    previa: false,
    previa_url: "",
    modalFormState: false,
    modalImportFormState: false,
    modalImportDataState: false,
    working: true,
    workingModal: true,
    cat_select: false,
    toggle: false,
    paginaActual: 0,
    paginaActual_ce: 0,
    paginas: 0,
    paginas_vi: 0,
    registros: 0,
    registros_vi: 0,
    casos_especiales: [],
    producto_registrado: true,
    activeTab: "1",
    buscar: {},
    cat_paises: Api.loadCatalogue("countries"),
    cat_empaques: Api.loadCatalogue("cat_empaque"),
    cat_tipo_importacion: Api.loadCatalogue("cat_tipo_importacion"),
    cat_estatus_tramite: Api.loadCatalogue("cat_estatus_tramite"),
    cat_unidad_medidas: Api.loadCatalogue("cat_unidad_medida"),
    cat_fabricantes: [],
    cat_importadores: [],
    cat_presentacion: [],
    cat_productos: [],
    cat_especies: Api.loadCatalogue("cat_especie"),
    cat_especies_reg: [],
    cat_categorias: [],
    importador: "",
    cat_materia_prima: Api.loadCatalogue("cat_materia_prima"),
    folio_solicitud: "",
    establecimiento: {
      razon_social: "",
      cedula_ruc: "",
      direccion: "",
      correo_electronico: "",
      telefono: "",
      representante_legal: "",
      actividad_id: "",
    },
    importacion: {
      importador_id: "",
      importador: "",
      fabricante_id: "",
      guia_area: "",
      fabricante: "",
      pais_origen: "",
      pais_procedencia: "",
      no_factura: "",
      nombre_solicita: "",
      peticion: "",
      productos: [],
      tipo: "",
      actividad_id: "",
    },
    producto: {
      producto_id: "",
      pais_origen_id: "",
      pais_origen_texto: "",
      nombre_comercial: "",
      materia_prima_id: "",
      materia_prima_texto: "",
      cantidad_producto: "",
      empaque_texto: "",
      empaque_id: "",
      cantidad_empaque: "",
      unidad_medida_texto: "",
      unidad_medida_id: "",
      especie_id: "",
      especie_texto: "",
      categoria_id: "",
      categoria_texto: "",
      fabricante_id: "",
      fabricante_texto: "",
      tipo_producto_veterinario_id: "",
    },
    caso_especial: {
      id: "",
      solicitud_id: "",
      tipo_importacion_id: "",
      usuario_id: "",
      folio_establecimiento: "",
      status: "",
      created: "",
      modified: "",
      casos_especiales_establecimiento_id: "",
      documentacion: [],
      datos_importacion: {},
      establecimiento: {},
      tipo_importacion: {},
      productos: [],
      todosDocsAprobados: false,
    },
    solicitud_ce: {
      id: "",
      folio_solicitud: "",
      accion_id: "",
      tramite_id: "",
      estatus_tramite_id: "",
      fecha_solicitud: "",
      estatus: {},
      tramite: {},
      accion: {},
    },
    empaque: "",
    especie: "",
    categoria: "",
    unidad_medida: "",
    tipo_importacion_id: "",
    estatus_tramite_id: "",
    fabricante: "",
    fabricante_registrado: true,
    materia_prima: "",
    producto_select: "",
    presentacion: "",
    pais_origen: "",
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.filtrarCatEstatusTramite();
    this.getSolicitudesCasosEspecialesClient(1);
  }

  filtrarCatEstatusTramite = () => {
    let cat_estatus = this.state.cat_estatus_tramite;

    let cat_filtrado = cat_estatus.filter((item) =>
      ["4", "5", "9", "7", "16", "18"].includes(item.id)
    );

    this.setState({ cat_estatus_tramite: cat_filtrado });
  };

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (evt, obj) => {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
    [
      "folio_solicitud",
      "tipo_importacion",
      "fecha_tramite",
      "establecimiento_solicitante",
      "estatus_tramite",
    ].includes(evt.target.name)
      ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
      : (this.search[evt.target.name] = evt.target.value);
    this.setState({ buscar: this.search });
  };

  // cleanSearch = () => {
  //   let search = this.state.buscar;

  //   for (const prop in search) {
  //     delete search[prop];
  //     document.getElementById(prop).value = "";
  //   }

  //   this.setState({ buscar: search });
  //   this.getSolicitudesCasosEspecialesClient(1);
  // };

  //Funcion para cambiar de pagina en el grid de regente
  getSolicitudesCasosEspecialesClient = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch(
      "app/getSolicitudesCasosEspecialesClient?page=" + page + src
    ).then((ce) => {
      if (ce) {
        this.setState({
          casos_especiales: ce.data,
          paginas: ce.last_page,
          registros: ce.total,
          paginaActual: ce.current_page,
          workingGrid: false,
        });
      }
    });
  };

  handleEstablecimientoChange = (e) => {
    let targetName = e.target.name,
      establecimiento = this.state.establecimiento;

    this.cleanErrorsValidation(targetName);

    switch (targetName) {
      case "razon_social":
        establecimiento.razon_social = e.target.value.toUpperCase();
        this.setState({ establecimiento: establecimiento });
        break;
      case "cedula_ruc":
        establecimiento.cedula_ruc = e.target.value.toUpperCase();
        this.setState({ establecimiento: establecimiento });
        break;
      case "direccion":
        establecimiento.direccion = e.target.value.toUpperCase();
        this.setState({ establecimiento: establecimiento });
        break;
      case "correo_electronico":
        establecimiento.correo_electronico = e.target.value.toLowerCase();
        this.setState({ establecimiento: establecimiento });
        break;
      case "telefono":
        if (this.checkPositiveIntegersWithZero(e.target.value)) {
          establecimiento.telefono = e.target.value;
          this.setState({ establecimiento: establecimiento });
        }
        break;
      case "representante_legal":
        establecimiento.representante_legal = e.target.value.toUpperCase();
        this.setState({ establecimiento: establecimiento });
        break;

      default:
        break;
    }
  };

  handleImportacionDataChange = (e) => {
    let targetName = e.target.name,
      importacion = this.state.importacion,
      targetValue = e.target.value;

    this.cleanErrorsValidation(targetName);

    switch (targetName) {
      case "fabricante":
        importacion.fabricante = targetValue.toUpperCase();
        break;
      case "no_factura":
        importacion.no_factura = targetValue.toUpperCase();
        break;
      case "nombre_solicita":
        importacion.nombre_solicita = targetValue.toUpperCase();
        break;
      case "peticion":
        importacion.peticion = targetValue.toUpperCase();
        break;

      default:
        break;
    }

    this.setState({ importacion: importacion });
  };

  handlePaisOrigenChange = (obj) => {
    this.cleanErrorsValidation("pais_origen");
    let importacion = this.state.importacion;
    importacion.pais_origen = obj.id;
    this.setState({ importacion: importacion });
  };

  handlePaisOrigenListadoChange = (obj) => {
    this.cleanErrorsValidation("pais_origen");
    let producto = this.state.producto;
    producto.pais_origen_id = obj.id;
    producto.pais_origen_texto = obj.descripcion.toUpperCase();
    this.setState({ producto: producto, pais_origen: obj });
  };

  handlePresentacionSelectChange = (obj) => {
    this.cleanErrorsValidation("presentacion");
    let producto = this.state.producto;
    producto.empaque_id = obj.empaque_id;
    producto.cantidad_empaque = obj.cantidad;
    producto.empaque_texto = obj.empaque.toUpperCase();
    producto.unidad_medida_id = obj.unidad_medida_id;
    producto.unidad_medida_texto = obj.unidad_medida;

    this.setState({ producto: producto, presentacion: obj });
  };

  handlePaisProcedenciaChange = (obj) => {
    this.cleanErrorsValidation("pais_procedencia");
    let importacion = this.state.importacion;
    importacion.pais_procedencia = obj.id;
    this.setState({ importacion: importacion });
  };

  handleTipoProductoChange = (e) => {
    this.cleanErrorsValidation("tipo");
    let importacion = this.state.importacion,
      producto = this.state.producto;

    importacion.tipo = e.target.value;

    if (this.state.tipo_importacion_id === "7") {
      importacion.productos = [];
      importacion.fabricante_id = this.initialState.importacion.fabricante_id;
      importacion.fabricante = this.initialState.importacion.fabricante;
      producto = this.initialState.producto;
      producto.fabricante_id = this.initialState.producto.fabricante_id;
      producto.fabricante_texto = this.initialState.producto.fabricante_texto;

      this.setState({
        producto: producto,
        fabricante: this.initialState.fabricante,
        fabricante_registrado: this.initialState.fabricante_registrado,
        materia_prima: this.initialState.materia_prima,
        pais_origen: this.initialState.pais_origen,
        empaque: this.initialState.empaque,
        unidad_medida: this.initialState.unidad_medida,
      });
    }

    this.setState({
      importacion: importacion,
    });
  };

  handleProductoChange = (e) => {
    let targetName = e.target.name,
      targetValue = e.target.value,
      producto = { ...this.state.producto };

    switch (targetName) {
      case "nombre_comercial":
        this.cleanErrorsValidation(targetName);
        producto.nombre_comercial = targetValue.toUpperCase();
        break;
      case "cantidad_producto":
        if (this.checkPositiveIntegersWithoutZero(targetValue)) {
          this.cleanErrorsValidation(targetName);
          producto.cantidad_producto = targetValue;
        }
        break;
      case "cantidad_empaque":
        if (this.checkPositiveIntegersWithoutZero(targetValue)) {
          this.cleanErrorsValidation(targetName);
          producto.cantidad_empaque = targetValue;
        }
        break;
      case "fabricante":
        this.cleanErrorsValidation(targetName);
        producto.fabricante_id = "";
        producto.fabricante_texto = targetValue.toUpperCase();
        break;

      default:
        break;
    }

    this.setState({ producto: producto });
  };

  handleEspecieSelectChange = (obj) => {
    let producto = { ...this.state.producto };

    this.cleanErrorsValidation("especie");
    this.cleanErrorsValidation("categoria");

    if (!["7"].includes(this.state.tipo_importacion_id)) {
      if (obj) {
        this.getCategoriasEspecie(obj.id);

        if (!["1", "5", "6", "7"].includes(obj.id.toString())) {
          this.setState({ cat_select: true });
        } else {
          this.setState({ cat_select: this.initialState.cat_select });
        }

        producto.especie_id = obj.id;
        producto.especie_texto = obj.descripcion.toUpperCase();
        producto.categoria_id = this.initialState.producto.categoria_id;
        producto.categoria_texto = this.initialState.producto.categoria_texto;

        this.setState({
          especie: obj,
          producto: producto,
          categoria: this.initialState.categoria,
        });
      } else {
        producto.especie_id = this.initialState.producto.especie_id;
        producto.especie_texto = this.initialState.producto.especie_texto;
        producto.categoria_id = this.initialState.producto.categoria_id;
        producto.categoria_texto = this.initialState.producto.categoria_texto;

        this.setState({
          especie: this.initialState.especie,
          producto: producto,
          categoria: this.initialState.categoria,
          cat_select: this.initialState.cat_select,
        });
      }
    }
  };

  handleCategoriaSelectChange = (obj) => {
    let producto = { ...this.state.producto };

    this.cleanErrorsValidation("categoria");

    if (!["7"].includes(this.state.tipo_importacion_id)) {
      producto.categoria_id = obj.id;
      producto.categoria_texto = obj.descripcion.toUpperCase();

      this.setState({ categoria: obj, producto: producto });
    }
  };

  getProductPresentation = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductPresentation?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ cat_presentacion: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getProductSpecies = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductSpecies?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          if (
            this.state.producto_registrado &&
            ["1", "8"].includes(this.state.tipo_importacion_id)
          ) {
            this.setState({ cat_especies_reg: data });
          } else {
            this.setState({ cat_especies: data });
          }
        }
      })
      .then((data) => Api.loading(false));
  };

  getCategoriasEspecie = (especie_id) => {
    Api.loading(true);
    Api.fetch(
      "app/getCategoriasByEspecieID?especie_id=" +
        especie_id +
        "&producto_registrado=" +
        this.state.producto_registrado +
        "&tipo_importacion_id=" +
        this.state.tipo_importacion_id +
        "&producto_id=" +
        this.state.producto.producto_id
    )
      .then((data) => {
        if (data) {
          this.setState({ cat_categorias: data });
        }
      })
      .then((res) => {
        Api.loading(false);
      });
  };

  handleMateriaPrimaSelectChange = (obj) => {
    let producto = { ...this.state.producto };

    this.cleanErrorsValidation("materia_prima");

    producto.materia_prima_id = obj.id;
    producto.materia_prima_texto = obj.descripcion.toUpperCase();

    this.setState({ producto: producto, materia_prima: obj });
  };

  handleRegProductoEstatusChange = (e) => {
    this.cleanErrorsValidation("nombre_comercial");
    this.cleanErrorsValidation("presentacion");
    this.cleanErrorsValidation("cantidad_producto");
    this.cleanErrorsValidation("cantidad_empaque");
    this.cleanErrorsValidation("especie");
    this.cleanErrorsValidation("empaque");
    this.cleanErrorsValidation("unidad_medida");
    this.cleanErrorsValidation("categoria");

    this.setState({
      producto_registrado: e.target.checked,
      presentacion: this.initialState.presentacion,
      producto_select: this.initialState.producto_select,
      producto: this.initialState.producto,
      especie: this.initialState.especie,
      categoria: this.initialState.categoria,
      empaque: this.initialState.empaque,
      unidad_medida: this.initialState.unidad_medida,
      cat_presentacion: this.initialState.cat_presentacion,
      cat_especies: this.initialState.cat_especies,
      cat_especies_reg: this.initialState.cat_especies_reg,
      cat_categorias: this.initialState.cat_categorias,
      cat_select: this.initialState.cat_select,
    });
  };

  handleRegFabricanteEstatusChange = (e) => {
    let producto = { ...this.state.producto };

    producto.fabricante_id = this.initialState.producto.fabricante_id;
    producto.fabricante_texto = this.initialState.producto.fabricante_texto;

    this.setState({
      fabricante_registrado: e.target.checked,
      producto: producto,
      fabricante: this.initialState.fabricante,
    });
  };

  handleEmpaqueChange = (obj) => {
    let producto = { ...this.state.producto };

    this.cleanErrorsValidation("empaque");

    producto.empaque_id = obj.id;
    producto.empaque_texto = obj.descripcion.toUpperCase();

    this.setState({ producto: producto, empaque: obj });
  };

  handleUnidadMedidaChange = (obj) => {
    let producto = { ...this.state.producto };

    this.cleanErrorsValidation("unidad_medida");

    producto.unidad_medida_id = obj.id;
    producto.unidad_medida_texto = obj.descripcion;

    this.setState({ producto: producto, unidad_medida: obj });
  };

  handleFabricanteSelectChange = (obj) => {
    this.cleanErrorsValidation("fabricante");

    if (obj) {
      if (this.state.tipo_importacion_id === "1" && obj) {
        this.getProductosFabricante(obj.id);
      }

      if (this.state.tipo_importacion_id === "7") {
        if (this.state.importacion.tipo !== "2") {
          let producto = { ...this.state.producto };
          producto.fabricante_id = obj.id;
          producto.fabricante_texto = obj.razon_social.toUpperCase();

          this.setState({ producto: producto, fabricante: obj });
        } else {
          let importacion = { ...this.state.importacion };

          importacion.fabricante = obj.razon_social;
          importacion.fabricante_id = obj.id;
          // importacion.productos = [];
          importacion.actividad_id = obj.actividad_id;

          this.setState({
            importacion: importacion,
            fabricante: obj,
            // materia_prima: this.initialState.materia_prima,
            // pais_origen: this.initialState.pais_origen,
            cat_select: this.initialState.cat_select,
            nombre_comercial: this.initialState.nombre_comercial,
            // producto: this.initialState.producto,
            producto_select: this.initialState.producto_select,
            categoria: this.initialState.categoria,
            especie: this.initialState.especie,
            presentacion: this.initialState.presentacion,
            cat_presentacion: this.initialState.cat_presentacion,
            // unidad_medida: this.initialState.unidad_medida,
            // empaque: this.initialState.empaque,
          });
        }
      } else {
        let importacion = { ...this.state.importacion };

        importacion.fabricante = obj.razon_social;
        importacion.fabricante_id = obj.id;
        importacion.productos = [];
        importacion.actividad_id = obj.actividad_id;

        this.setState({
          importacion: importacion,
          fabricante: obj,
          materia_prima: this.initialState.materia_prima,
          pais_origen: this.initialState.pais_origen,
          cat_select: this.initialState.cat_select,
          nombre_comercial: this.initialState.nombre_comercial,
          producto: this.initialState.producto,
          producto_select: this.initialState.producto_select,
          categoria: this.initialState.categoria,
          especie: this.initialState.especie,
          presentacion: this.initialState.presentacion,
          cat_presentacion: this.initialState.cat_presentacion,
          unidad_medida: this.initialState.unidad_medida,
          empaque: this.initialState.empaque,
        });
      }
    } else {
      let importacion = { ...this.state.importacion };

      importacion.fabricante = this.initialState.importacion.fabricante;
      importacion.fabricante_id = this.initialState.importacion.fabricante_id;
      importacion.actividad_id = this.initialState.importacion.actividad_id;
      importacion.productos = [];

      this.setState({
        importacion: importacion,
        nombre_comercial: this.initialState.nombre_comercial,
        producto_select: this.initialState.producto_select,
        fabricante: this.initialState.fabricante,
        cat_productos: this.initialState.cat_productos,
        materia_prima: this.initialState.materia_prima,
        pais_origen: this.initialState.pais_origen,
        cat_select: this.initialState.cat_select,
        producto: this.initialState.producto,
        categoria: this.initialState.categoria,
        especie: this.initialState.especie,
        presentacion: this.initialState.presentacion,
        cat_presentacion: this.initialState.cat_presentacion,
        unidad_medida: this.initialState.unidad_medida,
        empaque: this.initialState.empaque,
        cat_especies: this.initialState.cat_especies,
        cat_categorias: this.initialState.cat_categorias,
      });
    }
  };

  handleProductoSelectChange = (obj) => {
    this.cleanErrorsValidation("nombre_comercial");

    let producto = { ...this.state.producto };

    producto.producto_id = obj.id;
    // producto.pais_origen_id = obj.pais_origen_id;
    producto.tipo_producto_veterinario_id = obj.tipo_producto_veterinario_id;
    producto.nombre_comercial = obj.nombre_comercial.toUpperCase();
    producto.especie_id = this.initialState.producto.especie_id;
    producto.especie_texto = this.initialState.producto.especie_texto;
    producto.categoria_id = this.initialState.producto.categoria_id;
    producto.categoria_texto = this.initialState.producto.categoria_texto;
    producto.cantidad_producto = this.initialState.producto.cantidad_producto;

    this.getProductPresentation(obj.id);
    this.getProductSpecies(obj.id);

    this.setState({
      producto: producto,
      producto_select: obj,
      especie: this.initialState.especie,
      categoria: this.initialState.categoria,
      cat_categorias: this.initialState.cat_categorias,
      cat_select: this.initialState.cat_select,
    });
  };

  handleImportadorSelectChange = (obj) => {
    let importacion = this.state.importacion;

    this.cleanErrorsValidation("importador");

    importacion.importador = obj.razon_social;
    importacion.importador_id = obj.id;
    importacion.actividad_id = obj.actividad_id;

    this.setState({ importacion: importacion, importador: obj });
  };

  openModalImportView = (e) => {
    Api.loading(true);

    let detalleCasoEspecialId = e.target.dataset.detalle_casos_especiales_id,
      folio_solicitud = e.target.dataset.folio_solicitud;

    Api.fetch(
      "app/getInfoCasoEspecial?detalle_caso_especial_id=" +
        detalleCasoEspecialId
    ).then((ce) => {
      this.setState({
        caso_especial: ce.caso_especial,
        solicitud_ce: ce.solicitud,
        working: false,
        modalImportDataState: true,
        folio_solicitud: folio_solicitud,
      });

      Api.loading(false);
    });
  };

  openDocumentsUploadModal = (e) => {
    let solicitud_id = e.target.id,
      tipo_importacion_id = e.target.dataset.tipo_importacion_id,
      detalle_casos_especiales_id =
        e.target.dataset.detalle_casos_especiales_id,
      datos_importacion_id = e.target.dataset.datos_importacion_id;
    //let orden = this.state.orden;

    const p = {
      id: e.target.id,
      actividad_id: null,
      solicitud_id,
      datos_importacion_id,
      detalle_casos_especiales_id,
      tipo_importacion_id,
    };

    Api.loading(true);

    Api.fetch(
      "app/getDocsObligatoriosCasosEspeciales?solicitud_id=" +
        solicitud_id +
        "&tipo_importacion_id=" +
        tipo_importacion_id
    ).then((files) => {
      Api.loading(false);
      let uploadDocs = Api.upload({
        target: "#cargaDocs",
        required: files.documentos,
        ok: files.aprobados,
        post: "app/setSpecialCaseDocs",
        exts: ".jpg, .jpeg, .png, .pdf",
        params: p,
        onFinish: (r) => {
          Swal.fire({
            title: "Carga de documentos",
            html: "Carga completa con éxito",
            icon: "success",
          });

          modalarchivos.close();
          this.getSolicitudesCasosEspecialesClient(this.state.paginaActual_ce);
          //mi_grid.go(0); // ir a la pagina actual - refrescar el grid
        },
      });

      let modalarchivos = Api.modal({
        title: "Documentación requerida",
        html: uploadDocs,
      });
    });
  };

  addProduct = (e) => {
    e.preventDefault();
    let producto = { ...this.state.producto },
      error = 0,
      importacion = this.state.importacion,
      tipoImportacion = this.state.tipo_importacion_id;

    // verificamos si hay un campo está vacio
    if (!producto.nombre_comercial && tipoImportacion !== "7") {
      this.handleSingleErrorForm(
        "nombre_comercial",
        "Ingrese nombre comercial."
      );
      error++;
    }

    if (!producto.materia_prima_id && tipoImportacion === "7") {
      this.handleSingleErrorForm("materia_prima", "Seleccione");
      error++;
    }

    if (["1", "8"].includes(tipoImportacion)) {
      if (!this.state.presentacion && this.state.producto_registrado) {
        this.handleSingleErrorForm("presentacion", "Seleccione");
        error++;
      }
    }

    if (!producto.cantidad_producto) {
      this.handleSingleErrorForm(
        "cantidad_producto",
        "Ingrese cantidad de producto."
      );
      error++;
    }

    if (
      !producto.empaque_id &&
      (!this.state.producto_registrado || !["1", "8"].includes(tipoImportacion))
    ) {
      this.handleSingleErrorForm("empaque", "Seleccione");
      error++;
    }

    if (
      !producto.cantidad_empaque &&
      (!this.state.producto_registrado || !["1", "8"].includes(tipoImportacion))
    ) {
      this.handleSingleErrorForm(
        "cantidad_empaque",
        "Ingrese cantidad de empaque."
      );
      error++;
    }

    if (
      !producto.unidad_medida_id &&
      (!this.state.producto_registrado || !["1", "8"].includes(tipoImportacion))
    ) {
      this.handleSingleErrorForm("unidad_medida", "Seleccione");
      error++;
    }

    if (["7"].includes(this.state.tipo_importacion_id)) {
      if (!producto.fabricante_texto && importacion.tipo !== "2") {
        this.handleSingleErrorForm("fabricante", "Seleccione");
        error++;
      }

      if (!producto.pais_origen_id) {
        this.handleSingleErrorForm("pais_origen", "Seleccione");
        error++;
      }
    }

    if (!["7"].includes(this.state.tipo_importacion_id)) {
      if (
        !["1", "8"].includes(this.state.tipo_importacion_id) &&
        !producto.pais_origen_id
      ) {
        this.handleSingleErrorForm("pais_origen", "Seleccione");
        error++;
      }

      if (!producto.especie_id) {
        this.handleSingleErrorForm("especie", "Seleccione");
        error++;
      }

      if (
        producto.especie_id &&
        !producto.categoria_id &&
        !["1", "5", "6", "7"].includes(producto.especie_id) &&
        this.state.cat_select
      ) {
        this.handleSingleErrorForm("categoria", "Seleccione");
        error++;
      }
    }

    if (error > 0) {
      return false;
    }

    // verificamos que el producto a agregar no se encuentre en la lista

    let productoListado = false,
      title = "¡Producto ya listado!",
      text = `El producto ${producto.nombre_comercial} con las características especificadas ya se encuentra listado`;

    if (this.state.tipo_importacion_id === "7") {
      title = "¡Materia ya prima listada!";
      text = `La materia prima ${producto.materia_prima_texto} con las características especificadas ya se encuentra listada`;
      productoListado = importacion.productos.some(
        (obj) => JSON.stringify(obj) === JSON.stringify(producto)
      );
    } else {
      productoListado = importacion.productos.some(
        (obj) => JSON.stringify(obj) === JSON.stringify(producto)
      );
    }

    if (productoListado) {
      Swal.fire({
        icon: "warning",
        title: title,
        text: text,
        confirmButtonText: "Regresar",
      });
      return false;
    }

    importacion.productos.push(producto);

    if (
      this.state.tipo_importacion_id !== "1" &&
      this.state.tipo_importacion_id === "7" &&
      this.state.importacion.tipo !== "2"
    ) {
      this.setState({ fabricante: this.initialState.fabricante });
    }

    this.setState({
      importacion: importacion,
      producto: this.initialState.producto,
      empaque: this.initialState.empaque,
      unidad_medida: this.initialState.unidad_medida,
      materia_prima: this.initialState.materia_prima,
      pais_origen: this.initialState.pais_origen,
      especie: this.initialState.especie,
      categoria: this.initialState.categoria,
      cat_select: this.initialState.cat_select,
      producto_select: this.initialState.producto_select,
      presentacion: this.initialState.presentacion,
      cat_especies_reg: this.initialState.cat_especies_reg,
      cat_categorias: this.initialState.cat_categorias,
    });
  };

  handleGuiaAreaChange = (e) => {
    let importacion = { ...this.state.importacion };

    importacion.guia_area = e.target.value.toUpperCase();

    this.setState({ importacion: importacion });
  };

  removeProduct = (e) => {
    e.preventDefault();

    let importacion = this.state.importacion;

    importacion.productos.splice(e.target.id, 1);

    this.setState({ importacion: importacion });
  };

  handleImportSubmit = (e) => {
    e.preventDefault();

    let importacionData = { ...this.state };

    delete importacionData.activeTab;
    delete importacionData.buscar;
    delete importacionData.casos_especiales;
    delete importacionData.paginaActual;
    delete importacionData.paginaActual_ce;
    delete importacionData.paginas;
    delete importacionData.paginas_vi;
    delete importacionData.previa;
    delete importacionData.previa_url;
    delete importacionData.registros;
    delete importacionData.registros_vi;
    delete importacionData.toggle;
    delete importacionData.working;
    delete importacionData.workingGrid;
    delete importacionData.workingModal;
    delete importacionData.collapse;
    delete importacionData.modalFormState;
    delete importacionData.modalImportFormState;
    delete importacionData.modalImportDataState;
    delete importacionData.cat_empaques;
    delete importacionData.cat_paises;
    delete importacionData.cat_unidad_medidas;
    delete importacionData.empaque;
    delete importacionData.establecimiento;
    delete importacionData.producto;
    delete importacionData.unidad_medida;
    delete importacionData.cat_fabricantes;
    delete importacionData.cat_importadores;
    delete importacionData.cat_presentacion;
    delete importacionData.cat_materia_prima;
    delete importacionData.fabricante;
    delete importacionData.materia_prima;
    delete importacionData.importador;
    delete importacionData.cat_categorias;
    delete importacionData.cat_especies;
    delete importacionData.cat_especies_reg;
    delete importacionData.categoria;
    delete importacionData.especie;
    delete importacionData.pais_origen;
    delete importacionData.producto_registrado;
    delete importacionData.producto_select;
    delete importacionData.cat_productos;
    delete importacionData.cat_select;
    delete importacionData.fabricante_registrado;
    delete importacionData.categoria;
    delete importacionData.pais_procedencia;
    delete importacionData.presentacion;

    let title = "¡Lista de productos vacía!",
      text = "Debe ingresar al menos un producto en la lista";

    if (this.state.tipo_importacion_id === "7") {
      title = "¡Lista de materias primas vacía!";
      text = "Debe ingresar al menos una materia prima en la lista";
    }

    if (importacionData.importacion.productos.length === 0) {
      Swal.fire({
        icon: "warning",
        title: title,
        text: text,
        confirmButtonText: "Regresar",
      });
      return false;
    }

    Swal.fire({
      icon: "question",
      title: "¿Completar transacción?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/StoreImportData", importacionData, "POST").then(
          (data) => {
            if (data.errors) {
              this.handleEstablishmentFormValidations(data.errors);
              Api.loading(false);
              return false;
            } else {
              Api.loading(false);
              Swal.fire({
                icon: "success",
                title:
                  "¡Los datos de importación han sido guardados correctamente!",
                confirmButtonText: "Continuar",
                timer: 3000,
              }).then(() => {
                window.location.href = "/solicitud-casos-especiales";
              });
            }
          }
        );
      }
    });
  };

  handleEstablishmentSubmit = (e) => {
    e.preventDefault();

    let establecimientoData = { ...this.state };

    delete establecimientoData.activeTab;
    delete establecimientoData.buscar;
    delete establecimientoData.casos_especiales;
    delete establecimientoData.paginaActual;
    delete establecimientoData.paginaActual_ce;
    delete establecimientoData.paginas;
    delete establecimientoData.paginas_vi;
    delete establecimientoData.previa;
    delete establecimientoData.previa_url;
    delete establecimientoData.registros;
    delete establecimientoData.registros_vi;
    delete establecimientoData.toggle;
    delete establecimientoData.working;
    delete establecimientoData.workingGrid;
    delete establecimientoData.workingModal;
    delete establecimientoData.collapse;
    delete establecimientoData.modalFormState;
    delete establecimientoData.modalImportFormState;
    delete establecimientoData.modalImportDataState;
    delete establecimientoData.cat_empaques;
    delete establecimientoData.cat_paises;
    delete establecimientoData.cat_unidad_medidas;
    delete establecimientoData.cat_fabricantes;
    delete establecimientoData.cat_importadores;
    delete establecimientoData.cat_presentacion;
    delete establecimientoData.cat_materia_prima;
    delete establecimientoData.cat_productos;
    delete establecimientoData.empaque;
    delete establecimientoData.fabricante;
    delete establecimientoData.importacion;
    delete establecimientoData.importador;
    delete establecimientoData.materia_prima;
    delete establecimientoData.producto;
    delete establecimientoData.producto_registrado;
    delete establecimientoData.producto_select;
    delete establecimientoData.unidad_medida;
    delete establecimientoData.cat_categorias;
    delete establecimientoData.cat_especies;
    delete establecimientoData.cat_especies_reg;
    delete establecimientoData.categoria;
    delete establecimientoData.especie;
    delete establecimientoData.fabricante_registrado;
    delete establecimientoData.pais_origen;
    delete establecimientoData.cat_select;
    delete establecimientoData.presentacion;

    Swal.fire({
      icon: "question",
      title: "¿Completar transacción?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/UpdateCasoEspecial", establecimientoData, "POST").then(
          (data) => {
            if (data.errors) {
              this.handleEstablishmentFormValidations(data.errors);
              Api.loading(false);
              return false;
            } else {
              Api.loading(false);
              Swal.fire({
                icon: "success",
                title:
                  "¡Los datos del establecimiento han sido guardados correctamente!",
                confirmButtonText: "Continuar",
                timer: 3000,
              }).then(() => {
                window.location.href = "/solicitud-casos-especiales";
              });
            }
          }
        );
      }
    });
  };

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error", text = "") {
    Swal.fire({
      title: title,
      icon: icon,
      text: text,
      timer: 7000,
      confirmButtonText: "Regresar",
    });
    return false;
  }

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  handleEstablishmentFormValidations = (errors) => {
    for (const i in errors) {
      let targetName = i.split(".")[1];
      document.getElementById(targetName + "-error").style.display = "block";
      document.getElementById(targetName + "-error").innerText = errors[i];
      document.getElementById(targetName).classList.add("is-invalid");
    }
  };

  handleSingleErrorForm = (error, msg) => {
    document.getElementById(error + "-error").style.display = "block";
    document.getElementById(error + "-error").innerText = msg;
    document.getElementById(error).classList.add("is-invalid");
  };

  handleListaSolicitudesCasosEspeciales = (e) => {
    this.getSolicitudesCasosEspecialesClient(e.target.value);
  };

  handleModalImportDataCloseBtn = (e) => {
    this.setState({
      modalImportDataState: this.initialState.modalImportDataState,
      caso_especial: this.initialState.caso_especial,
      solicitud_ce: this.initialState.solicitud_ce,
      folio_solicitud: this.initialState.folio_solicitud,
    });
  };

  handleModalFormCloseBtn = (evt) => {
    evt.preventDefault();

    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#4CD964",
      denyButtonColor: "red",
      denyButtonText: "Cancelar",
      confirmButtonText: "Aceptar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.resetStates();
      }
    });
  };

  resetStates = () => {
    this.setState({
      workingModal: this.initialState.workingModal,
      modalFormState: this.initialState.modalFormState,
      modalImportFormState: this.initialState.modalImportFormState,
      modalImportDataState: this.initialState.modalImportDataState,
      fabricante: this.initialState.fabricante,
      pais_origen: this.initialState.pais_origen,
      pais_procedencia: this.initialState.pais_procedencia,
      materia_prima: this.initialState.materia_prima,
      folio_solicitud: this.initialState.folio_solicitud,
      empaque: this.initialState.empaque,
      unidad_medida: this.initialState.unidad_medida,
      tipo_importacion_id: this.initialState.tipo_importacion_id,
      estatus_tramite_id: this.initialState.estatus_tramite_id,
      producto_select: this.initialState.producto_select,
      presentacion: this.initialState.presentacion,
      especie: this.initialState.especie,
      catergoria: this.initialState.catergoria,
      cat_categorias: this.initialState.cat_categorias,
      cat_productos: this.initialState.cat_productos,
      cat_select: this.initialState.cat_select,
      cat_especies_reg: this.initialState.cat_especies_reg,
      producto_registrado: this.initialState.producto_registrado,
      establecimiento: {
        razon_social: "",
        cedula_ruc: "",
        direccion: "",
        correo_electronico: "",
        telefono: "",
        representante_legal: "",
      },
      importacion: {
        importador_id: "",
        importador: "",
        fabricante_id: "",
        guia_area: "",
        fabricante: "",
        pais_origen: "",
        pais_procedencia: "",
        no_factura: "",
        nombre_solicita: "",
        peticion: "",
        productos: [],
        tipo: "",
        actividad_id: "",
      },
      producto: {
        producto_id: "",
        pais_origen_id: "",
        pais_origen_texto: "",
        nombre_comercial: "",
        materia_prima_id: "",
        materia_prima_texto: "",
        cantidad_producto: "",
        empaque_texto: "",
        empaque_id: "",
        cantidad_empaque: "",
        unidad_medida_texto: "",
        unidad_medida_id: "",
        especie_id: "",
        especie_texto: "",
        categoria_id: "",
        categoria_texto: "",
        fabricante_id: "",
        fabricante_texto: "",
        tipo_producto_veterinario_id: "",
      },
    });
  };

  handleModalEstablecimientoCloseBtn = (evt) => {
    evt.preventDefault();

    this.setState({
      workingModal: true,
      modalFormState: false,
      establecimiento: {
        razon_social: "",
        cedula_ruc: "",
        direccion: "",
        correo_electronico: "",
        telefono: "",
        representante_legal: "",
      },
    });
  };

  handleCloseBtn = (evt) => {
    this.setState({ previa: false });
  };

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegersWithZero = (str) => {
    let regex = /^([0-9]\d{0,9})$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  checkPositiveIntegersWithoutZero = (str) => {
    let regex = /^[1-9]\d{0,9}$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  openModalEstablishmentInfoForm = (e) => {
    this.setState({
      modalFormState: true,
      workingModal: false,
      folio_solicitud: e.target.id,
    });
  };

  openModalImportInfoForm = (e) => {
    let tipoImportacion = e.target.dataset.tipo_importacion_id,
      folioSolicitud = e.target.id,
      importacion = { ...this.state.importacion };

    if (tipoImportacion === "8") {
      importacion.fabricante = e.target.dataset.razon_social;
      importacion.fabricante_id = e.target.dataset.establecimiento_id;

      this.getProductosFabricante(importacion.fabricante_id);
    } else {
      importacion.importador = e.target.dataset.razon_social;
      importacion.importador_id = e.target.dataset.establecimiento_id ?? "";
    }

    if (["1", "7", "8"].includes(tipoImportacion)) {
      //cargamos catálogo de fabricantes
      this.getEstablecimientosAsociados(
        tipoImportacion,
        e.target.dataset.establecimiento_id
      );
    }

    // if (["1"].includes(tipoImportacion)) {
    //   this.getProductosFabricante(importacion.importador_id);
    // }

    this.setState({
      tipo_importacion_id: tipoImportacion,
      modalImportFormState: true,
      folio_solicitud: folioSolicitud,
      workingModal: false,
      importacion: importacion,
    });
  };

  getEstablecimientosAsociados = (tipoImportacion, solicitante_id) => {
    Api.loading(true);
    Api.fetch(
      "app/getEstablecimientosAsociados?tipo_importacion_id=" +
        tipoImportacion +
        "&solicitante_id=" +
        solicitante_id
    ).then((data) => {
      if (tipoImportacion === "8") {
        this.setState({ cat_importadores: data });
      } else {
        this.setState({ cat_fabricantes: data });
      }

      Api.loading(false);
    });
  };

  getProductosFabricante = (establecimiento_id) => {
    Api.loading(true);
    Api.fetch(
      "app/getProductosFabricante?establecimiento_id=" + establecimiento_id
    ).then((data) => {
      this.setState({ cat_productos: data });
      Api.loading(false);
    });
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/solicitud-casos-especiales">Casos especiales</Link>
          </li>
        </ol>
        <h1 className="page-header">Casos especiales</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    CASOS ESPECIALES
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    CASOS ESPECIALES
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <fieldset>
                    <legend>Buscar</legend>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="folio_solicitud">
                            Folio solicitud:
                          </label>
                          <div className="input-group">
                            <input
                              id="folio_solicitud"
                              name="folio_solicitud"
                              placeholder="Ingrese folio de solicitud"
                              onChange={this.handleSearch}
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="tipo_importacion">
                            Tipo de importación:
                          </label>
                          <select
                            onChange={this.handleSearch}
                            name="tipo_importacion"
                            id="tipo_importacion"
                            className="form-control"
                          >
                            <option value="">Seleccione</option>
                            {this.state.cat_tipo_importacion.length > 0
                              ? this.state.cat_tipo_importacion.map(
                                  (ti, index) => (
                                    <option key={index} value={ti.id}>
                                      {ti.descripcion}
                                    </option>
                                  )
                                )
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="fecha_tramite">Fecha trámite:</label>
                          <div className="input-group">
                            <input
                              type="date"
                              name="fecha_tramite"
                              onChange={this.handleSearch}
                              id="fecha_tramite"
                              className="form-control"
                              placeholder="Fecha"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-7">
                        <div className="form-group">
                          <label htmlFor="establecimiento_solicitante">
                            Establecimiento solicitante:
                          </label>
                          <div className="input-group">
                            <input
                              id="establecimiento_solicitante"
                              name="establecimiento_solicitante"
                              placeholder="Ingrese establecimiento solicitante"
                              onChange={this.handleSearch}
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="estatus_tramite">
                            Estatus trámite:
                          </label>
                          <select
                            onChange={this.handleSearch}
                            name="estatus_tramite"
                            id="estatus_tramite"
                            className="form-control"
                          >
                            <option value="">Seleccione</option>
                            {this.state.cat_estatus_tramite.length > 0
                              ? this.state.cat_estatus_tramite.map(
                                  (ti, index) => (
                                    <option key={index} value={ti.id}>
                                      {ti.descripcion}
                                    </option>
                                  )
                                )
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <div className="input-group">
                            <button
                              type="button"
                              className="btn btn-orange w-100"
                              title="Buscar"
                              onClick={() =>
                                this.getSolicitudesCasosEspecialesClient(1)
                              }
                            >
                              <i className="fa fa-search"></i> Buscar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">TRÁMITE</th>
                        <th className="text-center">FOLIO SOLICITUD</th>
                        <th className="text-center">TIPO IMPORTACIÓN</th>
                        <th className="text-center">
                          ESTABLECIMIENTO SOLICITA
                        </th>
                        <th className="text-center">FECHA TRÁMITE</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center" width="10%"></th>
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.casos_especiales &&
                      Object.keys(this.state.casos_especiales).length > 0 ? (
                        this.state.casos_especiales.map((ce, index) => (
                          <tr
                            key={index}
                            className={
                              ce.estatus === "En espera" ? "alerta" : ""
                            }
                          >
                            <td className="text-center">
                              {ce.accion.toUpperCase()}
                            </td>
                            <td className="text-center">
                              {ce.folio_solicitud.toUpperCase()}
                            </td>
                            <td className="text-center">
                              {ce.tipo_importacion_txt.toUpperCase()}
                            </td>
                            <td className="text-center">{ce.est_nombre}</td>
                            <td className="text-center">
                              {ce.fecha_solicitud
                                .substr(0, 10)
                                .split("-")
                                .reverse()
                                .join("/")}
                            </td>
                            <td className="text-center">
                              {ce.estatus.toUpperCase()}
                            </td>
                            <td className="text-center">
                              {!ce.razon_social_solicitante ? (
                                <button
                                  className="btn bg-gradient-orange"
                                  title="Llenar formulario de datos de establecimiento"
                                  id={ce.folio_solicitud}
                                  onClick={this.openModalEstablishmentInfoForm}
                                >
                                  <i
                                    id={ce.folio_solicitud}
                                    className="fa fa-edit"
                                  ></i>
                                </button>
                              ) : ce.estatus_tramite_id === "16" ? (
                                <button
                                  className="btn bg-gradient-green"
                                  title="Llenar formulario de datos de importación"
                                  id={ce.folio_solicitud}
                                  data-establecimiento_id={ce.est_id}
                                  data-tipo_importacion_id={
                                    ce.tipo_importacion_id
                                  }
                                  data-razon_social={ce.est_nombre}
                                  onClick={this.openModalImportInfoForm}
                                >
                                  <i
                                    data-tipo_importacion_id={
                                      ce.tipo_importacion_id
                                    }
                                    data-razon_social={ce.est_nombre}
                                    data-establecimiento_id={ce.est_id}
                                    id={ce.folio_solicitud}
                                    className="fa fa-edit"
                                  ></i>
                                </button>
                              ) : ce.estatus_tramite_id === "7" ? (
                                <button
                                  className="btn bg-gradient-blue"
                                  title="Subir documentación"
                                  id={ce.id}
                                  data-tipo_importacion_id={
                                    ce.tipo_importacion_id
                                  }
                                  data-detalle_casos_especiales_id={
                                    ce.detalle_casos_especiales_id
                                  }
                                  data-datos_importacion_id={
                                    ce.datos_importacion_id
                                  }
                                  onClick={this.openDocumentsUploadModal}
                                >
                                  <i
                                    id={ce.id}
                                    data-tipo_importacion_id={
                                      ce.tipo_importacion_id
                                    }
                                    data-detalle_casos_especiales_id={
                                      ce.detalle_casos_especiales_id
                                    }
                                    data-datos_importacion_id={
                                      ce.datos_importacion_id
                                    }
                                    className="fa fa-paperclip"
                                  ></i>
                                </button>
                              ) : (
                                <button
                                  className="btn bg-gradient-blue"
                                  title="Ver datos de importación"
                                  id={ce.id}
                                  data-detalle_casos_especiales_id={
                                    ce.detalle_casos_especiales_id
                                  }
                                  data-folio_solicitud={ce.folio_solicitud}
                                  onClick={this.openModalImportView}
                                >
                                  <i
                                    id={ce.id}
                                    data-detalle_casos_especiales_id={
                                      ce.detalle_casos_especiales_id
                                    }
                                    data-folio_solicitud={ce.folio_solicitud}
                                    className="fa fa-eye"
                                  ></i>
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <b>No se encontraron registros</b>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getSolicitudesCasosEspecialesClient(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.getSolicitudesCasosEspecialesClient(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.getSolicitudesCasosEspecialesClient(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getSolicitudesCasosEspecialesClient(
                              this.state.paginas
                            );
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleListaSolicitudesCasosEspeciales}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
            {/* <div
            className={this.state.previa ? "previa" : "hide"}
            onContextMenu={(e) => e.preventDefault()}
          >
            <iframe
              title="Vista previa"
              className="rounded"
              src={this.state.previa_url}
              loading="eager"
            ></iframe>
            <center>
              <div className="btn-group">
                <button onClick={this.handleCloseBtn} className="btn btn-danger">
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
              </div>
            </center>
          </div> */}
            <Modal
              isOpen={this.state.modalFormState}
              tabIndex="-1"
              style={{
                maxWidth: "100%",
                width: "75%",
              }}
            >
              <ModalHeader
                width="100%"
                toggle={this.handleModalFormCloseBtn}
                className="text-center"
              >
                Folio de solicitud: {this.state.folio_solicitud}
              </ModalHeader>
              <ModalBody>
                <form
                  id="special-cases"
                  onSubmit={this.handleEstablishmentSubmit}
                >
                  <EstablishmentInfoForm
                    establecimiento={this.state.establecimiento}
                    workingModal={this.state.workingModal}
                    handleEstablecimientoChange={
                      this.handleEstablecimientoChange
                    }
                    handleModalFormCloseBtn={this.handleModalFormCloseBtn}
                  />
                </form>
              </ModalBody>
            </Modal>
            <Modal
              isOpen={this.state.modalImportFormState}
              tabIndex="-1"
              style={{
                maxWidth: "100%",
                width: "85%",
              }}
            >
              <ModalHeader
                width="100%"
                toggle={this.handleModalFormCloseBtn}
                className="text-center"
              >
                Folio de solicitud: {this.state.folio_solicitud}
              </ModalHeader>
              <ModalBody>
                <form id="special-cases" onSubmit={this.handleImportSubmit}>
                  {!["1", "7", "8"].includes(this.state.tipo_importacion_id) ? (
                    <GeneralImportTypeForm
                      state={this.state}
                      workingModal={this.state.workingModal}
                      handleImportacionDataChange={
                        this.handleImportacionDataChange
                      }
                      handlePaisOrigenListadoChange={
                        this.handlePaisOrigenListadoChange
                      }
                      handleModalFormCloseBtn={this.handleModalFormCloseBtn}
                      handlePaisOrigenChange={this.handlePaisOrigenChange}
                      handleGuiaAreaChange={this.handleGuiaAreaChange}
                      handleProductoChange={this.handleProductoChange}
                      handleEmpaqueChange={this.handleEmpaqueChange}
                      handlePaisProcedenciaChange={
                        this.handlePaisProcedenciaChange
                      }
                      handleUnidadMedidaChange={this.handleUnidadMedidaChange}
                      handleTipoProductoChange={this.handleTipoProductoChange}
                      addProduct={this.addProduct}
                      removeProduct={this.removeProduct}
                      handleEspecieSelectChange={this.handleEspecieSelectChange}
                      handleCategoriaSelectChange={
                        this.handleCategoriaSelectChange
                      }
                    ></GeneralImportTypeForm>
                  ) : this.state.tipo_importacion_id === "7" ? (
                    <ImportTypeSevenForm
                      state={this.state}
                      workingModal={this.state.workingModal}
                      handleImportacionDataChange={
                        this.handleImportacionDataChange
                      }
                      handlePaisOrigenChange={this.handlePaisOrigenChange}
                      handleProductoChange={this.handleProductoChange}
                      handlePaisOrigenListadoChange={
                        this.handlePaisOrigenListadoChange
                      }
                      handleEmpaqueChange={this.handleEmpaqueChange}
                      handleFabricanteSelectChange={
                        this.handleFabricanteSelectChange
                      }
                      handleGuiaAreaChange={this.handleGuiaAreaChange}
                      handleRegFabricanteEstatusChange={
                        this.handleRegFabricanteEstatusChange
                      }
                      handlePaisProcedenciaChange={
                        this.handlePaisProcedenciaChange
                      }
                      handleUnidadMedidaChange={this.handleUnidadMedidaChange}
                      handleMateriaPrimaSelectChange={
                        this.handleMateriaPrimaSelectChange
                      }
                      addProduct={this.addProduct}
                      removeProduct={this.removeProduct}
                      handleModalFormCloseBtn={this.handleModalFormCloseBtn}
                      handleTipoProductoChange={this.handleTipoProductoChange}
                    ></ImportTypeSevenForm>
                  ) : this.state.tipo_importacion_id === "8" ? (
                    <ImportTypeEightForm
                      state={this.state}
                      workingModal={this.state.workingModal}
                      handleProductoChange={this.handleProductoChange}
                      handleCategoriaSelectChange={
                        this.handleCategoriaSelectChange
                      }
                      removeProduct={this.removeProduct}
                      handleEmpaqueChange={this.handleEmpaqueChange}
                      handleUnidadMedidaChange={this.handleUnidadMedidaChange}
                      handleTipoProductoChange={this.handleTipoProductoChange}
                      handleEspecieSelectChange={this.handleEspecieSelectChange}
                      addProduct={this.addProduct}
                      handlePresentacionSelectChange={
                        this.handlePresentacionSelectChange
                      }
                      handleProductoSelectChange={
                        this.handleProductoSelectChange
                      }
                      handleImportacionDataChange={
                        this.handleImportacionDataChange
                      }
                      handlePaisOrigenChange={this.handlePaisOrigenChange}
                      handleImportadorSelectChange={
                        this.handleImportadorSelectChange
                      }
                      handlePaisProcedenciaChange={
                        this.handlePaisProcedenciaChange
                      }
                      handleModalFormCloseBtn={this.handleModalFormCloseBtn}
                      handleGuiaAreaChange={this.handleGuiaAreaChange}
                      handleRegProductoEstatusChange={
                        this.handleRegProductoEstatusChange
                      }
                    ></ImportTypeEightForm>
                  ) : this.state.tipo_importacion_id === "1" ? (
                    <ImportTypeOneForm
                      state={this.state}
                      workingModal={this.state.workingModal}
                      handleProductoChange={this.handleProductoChange}
                      handleCategoriaSelectChange={
                        this.handleCategoriaSelectChange
                      }
                      handleFabricanteSelectChange={
                        this.handleFabricanteSelectChange
                      }
                      removeProduct={this.removeProduct}
                      handleEmpaqueChange={this.handleEmpaqueChange}
                      handleUnidadMedidaChange={this.handleUnidadMedidaChange}
                      handleTipoProductoChange={this.handleTipoProductoChange}
                      handleEspecieSelectChange={this.handleEspecieSelectChange}
                      addProduct={this.addProduct}
                      handlePresentacionSelectChange={
                        this.handlePresentacionSelectChange
                      }
                      handleProductoSelectChange={
                        this.handleProductoSelectChange
                      }
                      handleImportacionDataChange={
                        this.handleImportacionDataChange
                      }
                      handlePaisOrigenChange={this.handlePaisOrigenChange}
                      handleImportadorSelectChange={
                        this.handleImportadorSelectChange
                      }
                      handlePaisProcedenciaChange={
                        this.handlePaisProcedenciaChange
                      }
                      handleModalFormCloseBtn={this.handleModalFormCloseBtn}
                      handleGuiaAreaChange={this.handleGuiaAreaChange}
                      handleRegProductoEstatusChange={
                        this.handleRegProductoEstatusChange
                      }
                    ></ImportTypeOneForm>
                  ) : null}
                </form>
              </ModalBody>
            </Modal>
            <Modal
              isOpen={this.state.modalImportDataState}
              tabIndex="-1"
              style={{
                maxWidth: "100%",
                width: "85%",
              }}
            >
              <ModalHeader
                width="100%"
                toggle={this.handleModalImportDataCloseBtn}
                className="text-center"
              >
                Folio de solicitud: {this.state.folio_solicitud}
              </ModalHeader>
              <ModalBody>
                <ImportDataView
                  state={this.state}
                  workingModal={this.state.workingModal}
                  handleModalImportDataCloseBtn={
                    this.handleModalImportDataCloseBtn
                  }
                ></ImportDataView>
              </ModalBody>
            </Modal>
            <div className="hide">
              <fieldset id="cargaDocs"></fieldset>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SpecialCases;
